import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AurSpinnerConfig, AurSpinnerSize } from '@shared/models/core-component.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aur-spinner',
  standalone: true,
  template: `<span [class]="classes" role="status" aria-label="Loading"></span>`,
})
export class AurSpinnerComponent {
  @Input() size: AurSpinnerSize = 16;
  @Input() intent: 'brand' | 'neutral' | 'on-solid' = 'brand';
  @Input() set config(value: AurSpinnerConfig | null | undefined) {
    if (!value) return;
    this.size = value.size ?? this.size;
    this.intent = value.intent ?? this.intent;
  }

  get classes(): string {
    const parts = ['spinner'];
    if (this.size !== 16) parts.push(`spinner--${this.size}`);
    if (this.intent !== 'brand') parts.push(`spinner--${this.intent}`);
    return parts.join(' ');
  }
}
